import { ATP_API_URL } from "../config/apiConfig";
import axios from "axios";
import { getAuthToken } from "../utils/index";

export const uploadDocumentAction = async ({
    file,
    documentRequirementId,
    entityId,
    entityDocumentId,
    actionType = "upload",
    onProgress,
}) => {
    console.log(`[Upload] === ${actionType.toUpperCase()} START ===`);
    console.log('[Upload] Endpoint:', ATP_API_URL.UPLOAD_DOCUMENT);
    console.log('[Upload] Payload:', {
        EntityDocumentId: entityDocumentId || 0,
        DocumentRequirementId: documentRequirementId,
        EntityId: entityId,
        ActionType: actionType,
        File: file?.name,
        FileSize: file?.size,
        FileType: file?.type,
    });

    try {
        const formData = new FormData();
        formData.append("EntityDocumentId", entityDocumentId || 0);
        formData.append("DocumentRequirementId", documentRequirementId);
        formData.append("EntityId", entityId);
        formData.append("ActionType", actionType);
        formData.append("File", file);

        const token = getAuthToken();
        const headers = { "Content-Type": "multipart/form-data" };
        if (token) headers["Authorization"] = `Bearer ${token}`;
        console.log('[Upload] Auth token present:', !!token);

        const response = await axios.post(ATP_API_URL.UPLOAD_DOCUMENT, formData, {
            headers,
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                console.log(`[Upload] Progress: ${percentCompleted}%`);
                if (onProgress) onProgress(percentCompleted);
            },
        });

        console.log('[Upload] Success — status:', response.status);
        console.log('[Upload] Response data:', response.data);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('[Upload] FAILED');
        console.error('[Upload] Status:', error.response?.status);
        console.error('[Upload] Error data:', error.response?.data);
        console.error('[Upload] Message:', error.message);
        return { success: false, error: error.response?.data || error.message };
    }
};
